// Unit preference helpers. Default: imperial (US market).
// Stored in localStorage for instant sync and persisted on profile via /api/profile.

const LS_KEY = 'unit_preference';

export function getUnit() {
  if (typeof window === 'undefined') return 'imperial';
  return localStorage.getItem(LS_KEY) || 'imperial';
}

export function setUnit(unit) {
  if (unit !== 'imperial' && unit !== 'metric') return;
  localStorage.setItem(LS_KEY, unit);
  // Fire event so listeners can re-render without a prop drill
  window.dispatchEvent(new CustomEvent('unit-preference-changed', { detail: unit }));
}

export function formatDistance(km, unit = getUnit()) {
  if (km == null || isNaN(km)) return '';
  if (unit === 'metric') return `${Math.round(km)} km`;
  const miles = km * 0.621371;
  return `${Math.round(miles)} mi`;
}

export function distanceLabel(unit = getUnit()) {
  return unit === 'metric' ? 'km' : 'mi';
}

export function kmToDisplay(km, unit = getUnit()) {
  if (unit === 'metric') return Math.round(km);
  return Math.round(km * 0.621371);
}

export function displayToKm(value, unit = getUnit()) {
  if (unit === 'metric') return Math.round(value);
  return Math.round(value / 0.621371);
}

export function formatHeight(cm, unit = getUnit()) {
  if (cm == null || isNaN(cm)) return '';
  if (unit === 'metric') return `${Math.round(cm)} cm`;
  // Round to nearest whole inch FIRST, then derive feet/inches from that integer.
  // This guarantees inches ∈ [0, 11] — eliminates any "5'12\"" edge case at
  // unit boundaries, regardless of float precision in cm/2.54.
  const totalInches = Math.round(cm / 2.54);
  const feet = Math.floor(totalInches / 12);
  const inches = totalInches - feet * 12;
  return `${feet}'${inches}"`;
}

// Return min/max height slider bounds that make sense for the unit
export function heightBounds(unit = getUnit()) {
  // cm under the hood. 140–220 cm covers ~4'7"–7'2"
  return { min: 140, max: 220 };
}
